var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switcher"},_vm._l((_vm.JACKET_SIDES),function(type,key){return _c('SwitchSideButton',{key:key,attrs:{"type":type,"is-active":type === _vm.side},on:{"onSwitch":_vm.onChangeJacketSide}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }